export default function({ app: { $helper, $bus } }) {
  return new Promise(resolve => {
    if ($helper.checkIfRefreshTokenIsRelevant()) return resolve()

    location.reload()
  })
}
